import { makeStyles, tokens } from "@fluentui/react-components";

export const useFormTextFieldStyle = makeStyles({
	field: {
		"& label": {
			fontSize: tokens.fontSizeBase200,
		},
	},
	inputField: {
		backgroundColor: tokens.colorNeutralBackground4,
	},
	fieldNoError: {
		paddingBottom: "16px",
		marginBottom: "2px",
	},
});
